import Axios from 'axios'
import _each from 'lodash/each'
import _filter from 'lodash/filter'
import _isArray from 'lodash/isArray'
import _keys from 'lodash/keys'

/*
|--------------------------------------------------------------------------
| MUTATIONS
|--------------------------------------------------------------------------
*/
export function all(state) {
  return state.collection
}

export function set(state, payload) {
  if (payload.field) {
    state[payload.field] = payload.value
  }
}

export const setOne = (state, payload) => {
  if (payload.resource) {
    const collection = _filter(state.collection, entry => {
      return entry.id !== payload.resource.id
    })
    collection.push(payload.resource)
    state.collection = collection
    return state.collection
  }
}

export function append(state, payload) {
  let field = payload.field || 'collection'
  let collection = state[field] || []
  collection.push(payload.value)
  state[field] = collection
}

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

export function create(
  context,
  url,
  payload,
  field = 'collection',
  axiosConfig = null,
  replaceCollection = true
) {
  let axios = window.axios
  if (!axios || axiosConfig) {
    axios = Axios.create(axiosConfig)
  } else {
    url = `/${context.rootGetters.currentTripDashboardId}${url}`
  }
  return new Promise(resolve => {
    axios.post(url, payload).then(
      res => {
        if ([200, 201].includes(res.status)) {
          context.commit('set', {
            field,
            value: replaceCollection
              ? res.data
              : updateCollectionWithResource(context.state[field], res.data)
          })

          resolve(res.data)
        }
      },
      () => {
        // error
        resolve()
        //reject(error);
      }
    )
  })
}

/*
|--------------------------------------------------------------------------
| UPDATE
|--------------------------------------------------------------------------
*/

export function update(
  context,
  url,
  payload,
  field = 'collection',
  axiosConfig = null,
  useVerb = false,
  replaceCollection = true
) {
  // @todo
  // refactor everything into using verb
  let axios = window.axios
  if (axiosConfig) {
    axios = window.Axios.create(axiosConfig)
  } else {
    url = `/${context.rootGetters.currentTripDashboardId}${url}`
  }
  return new Promise(resolve => {
    axios[useVerb ? 'put' : 'post'](url, payload).then(
      res => {
        if (res.status === 200) {
          context.commit('set', {
            field,
            value: replaceCollection
              ? res.data
              : updateCollectionWithResource(context.state[field], res.data)
          })
          resolve(res.data)
        }
      },
      e => {
        console.error(e)
        resolve()
        //reject(error);
      }
    )
  })
}

/*
|--------------------------------------------------------------------------
| DELETE
|--------------------------------------------------------------------------
*/

export function remove(
  context,
  url,
  payload,
  field = 'collection',
  axiosConfig = null,
  useVerb = false
) {
  // @todo refactor everything into using verb
  let axios = window.axios
  if (axiosConfig) {
    axios = window.Axios.create(axiosConfig)
  } else {
    url = `/${context.rootGetters.currentTripDashboardId}${url}`
  }
  return new Promise(resolve => {
    axios[useVerb ? 'delete' : 'post'](url, useVerb ? null : payload).then(
      res => {
        if (res.status === 200) {
          context.commit('set', {
            field,
            value: res.data
          })
          resolve(res.data)
        }
      },
      () => {
        resolve()
      }
    )
  })
}

export function fetchAllResources(
  context,
  url,
  field = 'collection',
  axiosConfig = null,
  bypassIfCollectionNotEmpty = false,
  force = false
) {
  if (force || !context.state.fetchAllResourcesDone) {
    context.commit('set', {
      field: 'fetchAllResourcesDone',
      value: true
    })
    return fetchResources(context, url, field, axiosConfig, bypassIfCollectionNotEmpty)
  }
}

export function fetchResources(
  context,
  url,
  field = 'collection',
  axiosConfig = null,
  bypassIfCollectionNotEmpty = false
) {
  if (bypassIfCollectionNotEmpty && context.state[field].length) {
    return resolvedPromise()
  } else {
    let axios = window.axios
    if (axiosConfig) {
      axios = Axios.create(axiosConfig)
    } else {
      url = `/${context.rootGetters.currentTripDashboardId}${url}`
    }
    return new Promise(resolve => {
      axios.get(url).then(
        res => {
          if (res.status === 200) {
            context.commit('set', {
              field,
              value: res.data
            })
            resolve(res.data)
          }
        },
        () => {
          resolve()
          //reject(error);
        }
      )
    })
  }
}

export function fetchResource(context, url, field = 'collection', axiosConfig = null) {
  let axios = window.axios
  if (axiosConfig) {
    axios = window.Axios.create(axiosConfig)
  } else {
    url = `/${context.rootGetters.currentTripDashboardId}${url}`
  }
  return new Promise(resolve => {
    axios.get(url).then(
      res => {
        if (res.status === 200) {
          let currentFieldValue = context.state[field].slice(0) || []
          currentFieldValue.push(res.data)
          context.commit('set', {
            field,
            value: currentFieldValue
          })
          resolve(currentFieldValue)
        }
      },
      () => {
        resolve()
        //reject(error);
      }
    )
  })
}

/*
|--------------------------------------------------------------------------
| GETTERS
|--------------------------------------------------------------------------
*/

export function forOwner(state) {
  return (ownerType, ownerId) => {
    return _filter(state.collection, entry => {
      if (entry) {
        return entry.owner_type === `App\\Models\\${ownerType}` && entry.owner_id === ownerId
      }
    })
  }
}

export function forQuery(state) {
  return query => {
    return _filter(state.collection, entry => {
      let valid = true
      _each(_keys(query), key => {
        // falsey collection entries
        if (!entry) {
          valid = false
          return false
        }

        // arrays
        if (_isArray(query[key])) {
          if (!query[key].includes(entry[key])) {
            valid = false
            return false
          }
        }

        // simple
        else if (entry[key] !== query[key]) {
          valid = false
          return false
        }
      })
      return valid
    })
  }
}

/*
|--------------------------------------------------------------------------
| HELPERS
|--------------------------------------------------------------------------
*/

// @todo: refactor into setOne
export function updateCollectionWithResource(collection, resource) {
  collection = collection.splice(0) || []
  collection = _filter(collection, e => {
    return e.id !== resource.id
  })
  collection.push(resource)
  return collection
}

function resolvedPromise() {
  return new Promise(resolve => {
    resolve()
  })
}
